import { isWebAddress } from "@shyne/shared/api";
import { z } from "zod";

export const NOT_A_WEB_ADDRESS = "Enter an address starting with http:// or https://";

export const optionalWebAddress = z
  .string()
  .trim()
  .refine((value) => value === "" || isWebAddress(value), NOT_A_WEB_ADDRESS)
  .optional();
